export interface CreateOrderListBibliographyListRequest {
  id: number
}

export function CreateOrderListBibliographyListRequestToJSON(
  value: CreateOrderListBibliographyListRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined
  }
}
